import React from 'react';

/**
 * LoadingState component for consistent loading indicators
 * Provides consistent loading styling and messaging
 */
const LoadingState = ({ 
  message = 'Loading...',
  size = 'medium',
  className = '',
  ...props 
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className={`flex flex-col items-center justify-center py-6 ${className}`} {...props}>
      <div className={`animate-spin rounded-full border-2 border-border-medium border-t-primary ${sizeClasses[size]} mb-4`}></div>
      <p className="text-text-muted text-sm">{message}</p>
    </div>
  );
};

export default LoadingState;
